// Static upload-requirements copy — shared so it's authored once regardless
// of where it's displayed.
export const UPLOAD_REQUIREMENT_SECTIONS = [
  {
    title: 'Supported Files',
    items: ['CSV', 'XLS', 'XLSX'],
  },
  {
    title: 'Required Structure',
    items: [
      'First row must contain headers.',
      'Headers cannot be blank.',
      'Headers must be unique.',
      'At least one worksheet must contain data.',
      'Empty worksheets are ignored.',
      'Password-protected files are not supported.',
    ],
  },
  // {
  //   title: 'Best Practices',
  //   items: [
  //     'If your dataset contains summary rows (such as Grand Totals or Subtotals), Datasphere will attempt to identify and handle them during analysis.',
  //     'Keep datasets as close to raw source data as possible for the most accurate analysis.',
  //     'Unmerged tables provide the best analysis results.',
  //     'Consistent values within each column improve data quality.',
  //     'Using a consistent date format helps Datasphere interpret dates correctly.',
  //   ],
  // },
];
